import { Swiper, SwiperSlide } from 'swiper/react'
import React from 'react'
import SwiperCore, { Navigation, Pagination, Mousewheel, A11y } from 'swiper'
import { NavigationArrow, gaEvent } from 'shared'
import { useCallback } from 'react'
import { BannerSwiperProps, BannerProps } from './types'

SwiperCore.use([Navigation, Pagination, Mousewheel, A11y])

export const BannerSwiper = ({ banners }: BannerSwiperProps): JSX.Element => {
  if (banners.length === 0) return <></>
  if (banners.length === 1) return <Banner index={0} {...banners[0]} />

  const slidesPerView = 2
  const showNavigationArrows = banners.length > slidesPerView

  return (
    <div className="generic-teaser-swiper select-none">
      {showNavigationArrows && (
        <div className="swiper-navigation swiper-navigation-left">
          <NavigationArrow id="banner-list-prev" direction="left" />
        </div>
      )}
      <Swiper
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
        navigation={{
          nextEl: `#banner-list-next`,
          prevEl: `#banner-list-prev`,
          disabledClass: 'is-disabled',
        }}
        roundLengths
        mousewheel={{ forceToAxis: true }}
        breakpoints={{ 450: { slidesPerView } }}
      >
        {banners.map((banner, index) => (
          <SwiperSlide key={banner.id}>
            <Banner index={index} {...banner} />
          </SwiperSlide>
        ))}
      </Swiper>
      {showNavigationArrows && (
        <div className="swiper-navigation swiper-navigation-right">
          <NavigationArrow direction="right" id="banner-list-next" />
        </div>
      )}
    </div>
  )
}

const Banner = ({ clicktracking_name, index, url, picture_url, alt_text }: BannerProps): JSX.Element => {
  const handleClick = useCallback(() => {
    gaEvent('navigation', `click banner_${clicktracking_name}`, `banner_position ${index + 1}`)
  }, [clicktracking_name, index])

  return (
    <div className="item swiper-slide">
      <a onClick={handleClick} href={url}>
        <img alt={alt_text} src={picture_url} />
      </a>
    </div>
  )
}
